import { createNotificationHelpers } from '@/helpers';
import { ref } from 'vue';
import { INotification } from '@/features/common/types';

export const useNotification = () => {
    const { notificationSuccess, notificationError, notificationWarning, notificationHide } = createNotificationHelpers();
    const notificationBarState = ref<INotification>(notificationHide());

    return {
        notificationBarState,
        notificationSuccess,
        notificationWarning,
        notificationError
    };
};
